import React, { useEffect } from "react";
import FileDropzone from "../components/FileDropzone";
import { getDataFromLocalStorage } from "../util/localStorage";
import { useNavigate } from "react-router-dom";

const UploadDocuments = () => {
  const navigate = useNavigate();

  const handleUploadSuccess = () => {
    // setTimeout(() => {
    //   //   window.location.href = "/documents/1";
    // }, 5000);
  };

  const handleUploadError = (error) => {
    // console.error("Upload error:", error);
    // Handle error as needed
  };

  return (
    <div className="bg-[#141a2a] p-[10px] pt-[110px] w-full min-h-[100vh]">
      <div className="bg-white max-w-[765px] w-full sm:p-12 p-4 mx-auto rounded-[10px]">
        <h3 className="sm:text-[30px] text-[20px] font-bold text-center text-[#767676] mb-[10px] relative">
          <span
            className="absolute left-0 cursor-pointer font-normal text-[20px] top-[10px] underline hover:text[#000]"
            onClick={() => navigate(-1)}
          >
            Back
          </span>{" "}
          Upload PDF
        </h3>

        <FileDropzone
          uploadUrl="YOUR_API_ENDPOINT"
          onUploadSuccess={handleUploadSuccess}
          onUploadError={handleUploadError}
        />
      </div>
    </div>
  );
};

export default UploadDocuments;
